export class JobStatus {
    id: number;
    description: string;
    actionLabel: string;

    private constructor(id: number, description: string, actionLabel: string) {
        this.id = id;
        this.description = description;
        this.actionLabel = actionLabel;
    }

    public static Open = new JobStatus(1, "Open", "open job");
    public static Paused = new JobStatus(10, "Paused", "pause job");
    public static Closed = new JobStatus(20, "Closed", "close job");
    public static Pending = new JobStatus(30, "Pending", "pending job");
    public static Requested = new JobStatus(40, "Requested", "requested job");

    public isOpen = () => this.id === 1;

    public isPaused = () => this.id == 10;

    public isClosed = () => this.id == 20;

    public isPending = () => this.id === 30;

    public isRequested = () => this.id === 40;

    public isPendingOrRequested = () => this.isPending() || this.isRequested();

    public isPausedOrClosed = () => this.isClosed() || this.isPaused();

    public isPausedOrClosedOrRequestedOrPending = () =>
        this.isClosed() ||
        this.isPaused() ||
        this.isPending() ||
        this.isRequested();

    public isOpenOrPaused = () => this.isOpen() || this.isPaused();

    public isOpenOrPausedOrClosed = () =>
        this.isOpen() || this.isPaused() || this.isClosed();

    public static asArray = () => [
        JobStatus.Open,
        JobStatus.Paused,
        JobStatus.Closed,
        JobStatus.Pending,
        JobStatus.Requested,
    ];

    public static fromId = (id: number) => {
        if (id === undefined) return undefined;
        const status = JobStatus.asArray().find(s => s.id === id);
        return status;
    };

    public static fromName = (value: string) => {
        if (value === undefined) return undefined;
        const status = JobStatus.asArray().find(s => s.description === value);
        return status;
    };
}
